import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    expert: {
      type: Object,
      required: true
    }
  },
  computed: mapGetters({
    loading: 'skiliko/experts/isLoading'
  }),
  methods: mapActions({
    save: 'skiliko/experts/save'
  })
}



// WEBPACK FOOTER //
// ./src/mixins/expert.js